export default __webpack_public_path__ + "static/media/posflight.8810001f.png";